import { Permission } from '@weave/schema-gen-ts/dist/shared/waccess';
import { AiReceptionistOrg } from '@wetags/ai-receptionist';
import { useSupportedBookingSoftware, useTruelarkDependency } from '@frontend/api-ai-settings';
import { checkAggregateACL } from '@frontend/auth-helpers';
import { useAppScopeStore } from '@frontend/scope';
import { AIR_COHORT } from '../constants';
import { useAiReceptionistAccess } from './use-ai-receptionist-access';

export const useAiScheduleAccess = () => {
  const { selectedLocationIds, selectedOrgId } = useAppScopeStore();
  const { hasTlAiReceptionistAccess, hasWeaveAiReceptionistAccess } = useAiReceptionistAccess();

  // TODO: Milind - remove this wetag once WEAVE_VOICE_AIR CF backfill is complete
  const [isAirSettingsEnabled, isAirSettingsEnabledLoading] = AiReceptionistOrg.useWetag('air-settings'); // wetag for new air-settings

  /**
   * Even though the ACL is named "AI_SETTINGS_WRITE", it is used to gate access to view and edit AI Receptionist settings.
   */
  const { aggregateValue: hasManagePermission } = checkAggregateACL(
    selectedLocationIds,
    Permission.AI_SETTINGS_WRITE,
    'all'
  );

  const airCohort =
    hasWeaveAiReceptionistAccess || isAirSettingsEnabled ? AIR_COHORT.STEELTHREAD : AIR_COHORT.BRIDGELINE;

  const { meetsTruelarkDependency, isLoading: isTruelarkDependencyLoading } = useTruelarkDependency({
    locationIds: selectedLocationIds,
    orgId: selectedOrgId,
    enabled: airCohort === AIR_COHORT.BRIDGELINE && hasManagePermission,
  });

  const { hasSupportedBookingSoftware, isLoading: isBookingSoftwareLoading } = useSupportedBookingSoftware({
    locationIds: selectedLocationIds,
    orgId: selectedOrgId,
    isEnabled: meetsTruelarkDependency && hasManagePermission,
  });

  const canViewBridgelineScheduleSettings =
    airCohort === AIR_COHORT.BRIDGELINE &&
    hasTlAiReceptionistAccess &&
    hasManagePermission &&
    hasSupportedBookingSoftware;
  const stillOnboardingBridgeline = airCohort === AIR_COHORT.BRIDGELINE && !meetsTruelarkDependency;
  /**
   * This only determines whether Bridgeline-backed schedule settings should be enabled.
   * Visibility decisions should be based on `canViewBridgelineScheduleSettings`.
   */
  const canEditBridgelineScheduleSettings = canViewBridgelineScheduleSettings && !stillOnboardingBridgeline;

  return {
    airCohort,
    canViewBridgelineScheduleSettings,
    canEditBridgelineScheduleSettings,
    hasAiReceptionistAccess: hasTlAiReceptionistAccess, // TODO: Check all consumers of this if they need AIR or TL AIR access
    isLoading: isTruelarkDependencyLoading || isBookingSoftwareLoading || isAirSettingsEnabledLoading,
  };
};
